import { Component, ViewEncapsulation, OnInit, AfterViewInit } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { AccountService, EventManager } from 'src/app/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Dispatcher, StoreResource } from './state';
import { environment } from 'src/environments/environment';
import { DateUtil } from './shared/util/date.util';
import { NzModalService } from 'ng-zorro-antd/modal';
declare var $;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'admin-robo';
  spinner: number = 0;
  isShowSpinner = false;
  constructor(
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private $localStorage: LocalStorageService,
    private $sessionStorage: SessionStorageService,
    private dispatcher: Dispatcher,
    private accountService: AccountService,
    public modalService: NzModalService,
    private toast: ToastrService,
    private eventManager: EventManager) {
    }
  ngOnInit() {
    this.eventManager.subscribe('show-spinner', (res) => {
      console.log('show spinner: ', DateUtil.parseDate(new Date(), 'hh:mm:ss'));
      // this.spinnerService.show();
      this.isShowSpinner = true;
    });
    this.eventManager.subscribe('close-spinner', (res) => {
      console.log('hide spinner: ', DateUtil.parseDate(new Date(), 'hh:mm:ss'));
      // this.spinnerService.hide();
      this.isShowSpinner = false;
    });
    this.eventManager.subscribe('Fmarket.authenError' , (content) => {
      this.modalService.closeAll();
      this.router.navigate(['/authentication/login']);
    });
    this.eventManager.subscribe('Fmarket.httpError' , (content) => {
      const message = content.message || content.content;
      if (message) {
        this.toast.error('Error: ', message || 'Error happen');
      }
    });
    const token = this.$sessionStorage.retrieve(environment.KEY_TOKEN) || this.$localStorage.retrieve(environment.KEY_TOKEN);
    if (token) {
      this.dispatcher.fire(new StoreResource());
    }
  }
  ngAfterViewInit(): void {
    $('body').on('click', (e) => {
      this.eventManager.broadcast({
        name: 'body-click',
        content: {
          event: e
        }
      })
    });
  }
  getResource() {

  }
}
